import * as React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { HomePageSustainabilityContent } from '../../../graphql/pimcore/modules/siteContent/types/HomePageContent';
import './sustainability.css';

type SustainabilityProps = {
    cmsContent: HomePageSustainabilityContent;
};

export default function Sustainability({ cmsContent }: SustainabilityProps) {
    const theme = useTheme();

    const { title, subtitle, titleBackgroundImage, mainText, detailsLink } = cmsContent;
    const subtitleLines = subtitle.content.split('\n') ?? [];

    return (
        <div className="orange-background">
            <div
                className="orange-background-with-image"
                style={
                    {
                        /* override only the URL part, other styles are inherited from CSS file */
                        '--sust-bg-url': `url(${titleBackgroundImage.imageUrl})`,
                    } as React.CSSProperties
                }
            >
                <div className="sustainability-container">
                    <div className="left-container ">
                        <div className="sustainability-title">{title.content}</div>
                        <div className="commitment">
                            {subtitleLines.map((line, i) => (
                                <span key={i}>
                                    {line}
                                    {i < subtitleLines.length - 1 && <br />}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="right-styling">
                        <Box
                            data-testid={'right-box'}
                            sx={{
                                [theme.breakpoints.between(1200, 1439)]: {
                                    marginLeft: '4rem',
                                },
                                [theme.breakpoints.between(1131, 1200)]: {
                                    marginLeft: '6rem',
                                    marginRight: '-7rem',
                                },
                                [theme.breakpoints.between(1101, 1131)]: {
                                    marginLeft: '5rem',
                                    marginRight: '-6rem',
                                },
                                [theme.breakpoints.between(1051, 1101)]: {
                                    paddingTop: '1rem',
                                    marginLeft: '5rem',
                                    marginRight: '-5rem',
                                },
                                [theme.breakpoints.between(1025, 1051)]: {
                                    paddingTop: '1rem',
                                    marginLeft: '5rem',
                                    marginRight: '-4rem',
                                },
                                [theme.breakpoints.between(1000, 1025)]: {
                                    paddingTop: '1rem',
                                    marginLeft: '4rem',
                                    marginRight: '-4rem',
                                },
                                [theme.breakpoints.between(992, 1000)]: {
                                    paddingTop: '1rem',
                                    marginLeft: '4rem',
                                    marginRight: '-3rem',
                                },
                            }}
                        >
                            <div className="sustainability-text">
                                <Box
                                    data-testid={'sustainability-text-content'}
                                    sx={{ height: '100%' }}
                                    className="self-stretch"
                                    dangerouslySetInnerHTML={{
                                        __html: mainText.sanitizedContent,
                                    }}
                                />
                                <div className="our-efforts">
                                    <Typography fontSize="1.5rem" fontWeight="400">
                                        <Link to={detailsLink.linkRoute} className="effort-styling">
                                            <ArrowForwardIcon style={{ fontSize: 'x-large' }} />{' '}
                                            {detailsLink.linkText}
                                        </Link>
                                        {/*temp comment this because Erek said "Remove Second Call to action"*/}
                                        {/*<a href="/#" className="impact-styling">*/}
                                        {/*    <ArrowForwardIcon style={{ fontSize: 'x-large' }} />{' '}*/}
                                        {/*    <FormattedMessage*/}
                                        {/*        id="OurImpact"*/}
                                        {/*        defaultMessage="Our Impact"*/}
                                        {/*    />*/}
                                        {/*</a>*/}
                                    </Typography>
                                </div>
                            </div>
                        </Box>
                    </div>
                </div>
            </div>
        </div>
    );
}
